import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import CustomLangCookies from 'i18n/customLanguageCookies';

import translationKO from 'i18n/languages/messages_ko_KR.json';
import translationKOPPP from 'i18n/languages/messages_ko_KR_PPP.json';
import translationEN from 'i18n/languages/messages_en_US.json';
import translationENPPP from 'i18n/languages/messages_en_US_PPP.json';
import translationFR from 'i18n/languages/messages_fr_FR.json';
import translationZH from 'i18n/languages/messages_zh_CN.json';
import translationTW from 'i18n/languages/messages_zh_TW.json';
import translationJP from 'i18n/languages/messages_ja_JP.json';
import translationVI from 'i18n/languages/messages_vi_VN.json';

const languageDetector = new LanguageDetector();
languageDetector.addDetector(CustomLangCookies);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['customLangCookies', 'navigator'],
      lookupCustomLangCookies: 'saveLanguage',
    },
    resources: {
      ko: {
        translation: translationKO,
      },
      ko_pg: {
        translation: translationKOPPP,
      },
      ko_pp: {
        translation: translationKOPPP,
      },
      en: {
        translation: translationEN,
      },
      en_pg: {
        translation: translationENPPP,
      },
      en_pp: {
        translation: translationENPPP,
      },
      zh: {
        translation: translationZH,
      },
      zh_pg: {
        translation: translationZH,
      },
      zh_pp: {
        translation: translationZH,
      },
      ja: {
        translation: translationJP,
      },
      ja_pg: {
        translation: translationJP,
      },
      ja_pp: {
        translation: translationJP,
      },
      tw: {
        translation: translationTW,
      },
      tw_pg: {
        translation: translationTW,
      },
      tw_pp: {
        translation: translationTW,
      },
      vi: {
        translation: translationVI,
      },
      vi_pg: {
        translation: translationVI,
      },
      vi_pp: {
        translation: translationVI,
      },
      fr: {
        translation: translationFR,
      },
      fr_pg: {
        translation: translationFR,
      },
      fr_pp: {
        translation: translationFR,
      },
    },
    fallbackLng: ['en'],
    interpolation: {
      escapeValue: false,
      skipOnVariables: false,
    },
    returnNull: true,
  });

export default i18n;
